(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gifting-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gifting-collection')) {
    const WISHLIST_KEY = 'gifting-collection:wishlist';

    class GiftingCollection extends HTMLElement {
      connectedCallback() {
        this.carousels = new Map();
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.live = this.querySelector('[data-gc-live]');
        this.cta = this.querySelector('[data-gc-cta]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));

        this.querySelectorAll('[data-gc-panel]').forEach((panel) => this.setupCarousel(panel));

        if (!this.bound) {
          this.bound = true;
          this.bindTabs();
          this.addEventListener('click', (event) => {
            const add = event.target.closest('[data-gc-add]');
            if (add) return this.addToCart(add);
            const heart = event.target.closest('[data-gc-wishlist]');
            if (heart) this.toggleWishlist(heart);
          });
        }
        this.restoreWishlist();
      }

      disconnectedCallback() {
        this.carousels.forEach((carousel) => carousel.destroy());
        this.carousels.clear();
      }

      /* Tabs */
      bindTabs() {
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => {
            const last = this.tabs.length - 1;
            let next = null;
            if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
            if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = last;
            if (next === null) return;
            event.preventDefault();
            this.tabs[next].focus();
            this.activate(this.tabs[next]);
          });
        });
      }

      activate(tab) {
        if (tab.getAttribute('aria-selected') === 'true') return;
        this.tabs.forEach((item) => {
          const on = item === tab;
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
            const carousel = this.carousels.get(panel);
            if (carousel) carousel.update();
          }
        });
        if (this.cta && this.cta.dataset.fixed !== 'true' && tab.dataset.url) this.cta.href = tab.dataset.url;
      }

      /* Carousel (CSS scroll-snap + controls) */
      setupCarousel(panel) {
        const track = panel.querySelector('[data-gc-track]');
        if (!track) return;
        const prev = panel.querySelector('[data-gc-prev]');
        const next = panel.querySelector('[data-gc-next]');
        const dotsWrap = panel.querySelector('[data-gc-dots]');
        const enabled = this.dataset.carousel !== 'false';
        const behavior = () => (this.reduceMotion.matches ? 'auto' : 'smooth');
        let pages = 0;
        let frame = 0;

        const measure = () => {
          const style = getComputedStyle(track);
          return {
            max: track.scrollWidth - track.clientWidth,
            gap: parseFloat(style.columnGap) || 0,
            pad: (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0),
          };
        };

        const buildDots = () => {
          if (!dotsWrap) return;
          dotsWrap.textContent = '';
          for (let i = 0; i < pages; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'gifting-collection__dot';
            dot.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + pages);
            dot.addEventListener('click', () => {
              const { max } = measure();
              track.scrollTo({ left: pages > 1 ? (max * i) / (pages - 1) : 0, behavior: behavior() });
            });
            dotsWrap.appendChild(dot);
          }
        };

        const update = () => {
          const { max } = measure();
          const scrollable = enabled && max > 2;
          if (prev) prev.hidden = !scrollable;
          if (next) next.hidden = !scrollable;
          if (dotsWrap) dotsWrap.hidden = !scrollable;
          if (!scrollable) return;

          const count = Math.max(2, Math.ceil((track.scrollWidth - 2) / track.clientWidth));
          if (count !== pages) {
            pages = count;
            buildDots();
          }
          const page = Math.round((track.scrollLeft / max) * (pages - 1));
          if (dotsWrap) {
            Array.from(dotsWrap.children).forEach((dot, i) => {
              dot.classList.toggle('is-active', i === page);
              if (i === page) dot.setAttribute('aria-current', 'true');
              else dot.removeAttribute('aria-current');
            });
          }
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
        };

        const move = (direction) => {
          const { gap, pad } = measure();
          track.scrollBy({ left: direction * (track.clientWidth - pad + gap), behavior: behavior() });
        };

        const onScroll = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(update);
        };

        track.addEventListener('scroll', onScroll, { passive: true });
        if (prev) prev.addEventListener('click', () => move(-1));
        if (next) next.addEventListener('click', () => move(1));

        const observer = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
        if (observer) observer.observe(track);
        else window.addEventListener('resize', update);
        update();

        this.carousels.set(panel, {
          update,
          destroy: () => {
            cancelAnimationFrame(frame);
            if (observer) observer.disconnect();
            else window.removeEventListener('resize', update);
          },
        });
      }

      /* Add to cart */
      announce(message) {
        if (!this.live) return;
        this.live.textContent = '';
        setTimeout(() => { this.live.textContent = message; }, 50);
      }

      async addToCart(button) {
        if (button.disabled || button.classList.contains('is-loading')) return;

        const label = button.querySelector('[data-gc-add-label]');
        const error = button.closest('[data-gc-buy]').querySelector('[data-gc-error]');
        const original = button.dataset.label || (label ? label.textContent : 'Add to Cart');
        button.dataset.label = original;
        error.hidden = true;
        error.textContent = '';
        button.classList.remove('is-added');
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Adding…';

        const variantId = Number(button.dataset.variantId);
        const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const payload = { id: variantId, quantity: 1 };
        if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
          payload.sections = cartElement.getSectionsToRender().map((section) => section.id).join(',');
          payload.sections_url = window.location.pathname;
        }

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'This item could not be added to your cart.');
          }

          if (cartElement && typeof cartElement.renderContents === 'function' && data.sections) {
            cartElement.renderContents(data);
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gifting-collection', productVariantId: variantId, cartData: data });
          }
          this.dispatchEvent(new CustomEvent('gifting-collection:added', { bubbles: true, detail: { variantId, item: data } }));

          button.classList.add('is-added');
          if (label) label.textContent = 'Added';
          this.announce((button.dataset.productTitle || 'Item') + ' added to your cart');
          setTimeout(() => {
            button.classList.remove('is-added');
            if (label) label.textContent = original;
          }, 2200);
        } catch (err) {
          if (label) label.textContent = original;
          error.textContent = err.message || 'Something went wrong. Please try again.';
          error.hidden = false;
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      }

      /* Wishlist: visual state + event, so an existing wishlist app can hook in */
      readWishlist() {
        try {
          return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        } catch (e) {
          return [];
        }
      }

      restoreWishlist() {
        const saved = this.readWishlist();
        this.querySelectorAll('[data-gc-wishlist]').forEach((heart) => {
          heart.setAttribute('aria-pressed', saved.includes(heart.dataset.productId) ? 'true' : 'false');
        });
      }

      toggleWishlist(heart) {
        const id = heart.dataset.productId;
        const active = heart.getAttribute('aria-pressed') !== 'true';
        let saved = this.readWishlist().filter((item) => item !== id);
        if (active) saved.push(id);
        try {
          localStorage.setItem(WISHLIST_KEY, JSON.stringify(saved));
        } catch (e) { /* storage unavailable */ }

        this.querySelectorAll('[data-gc-wishlist][data-product-id="' + id + '"]').forEach((item) => {
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.dispatchEvent(new CustomEvent('gifting-collection:wishlist', {
          bubbles: true,
          detail: { productId: id, handle: heart.dataset.productHandle, url: heart.dataset.productUrl, active },
        }));
      }
    }

    customElements.define('gifting-collection', GiftingCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('landing-page-slideshow')) {
    class LandingPageSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-lps-track]');
        this.slides = Array.from(this.querySelectorAll('[data-lps-slide]'));
        if (!this.track || !this.slides.length) return;

        this.dots = Array.from(this.querySelectorAll('[data-lps-dot]'));
        this.prevBtn = this.querySelector('[data-lps-prev]');
        this.nextBtn = this.querySelector('[data-lps-next]');
        this.pauseBtn = this.querySelector('[data-lps-pause]');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.viewport = this.querySelector('.lps__viewport');

        this.index = 0;
        this.count = this.slides.length;
        this.delay = (parseFloat(this.dataset.speed) || 6) * 1000;
        this.loop = this.dataset.loop !== 'false';
        this.autoplay = this.dataset.autoplay === 'true';
        this.hoverPause = this.dataset.hoverPause !== 'false';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        this.userPaused = false;
        this.hovered = false;
        this.inView = true;
        this.editing = false;
        this.timer = null;

        this.videos.forEach((video) => {
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('aria-hidden', 'true');
          video.addEventListener('playing', () => video.classList.add('is-ready'));
        });

        this.bind();
        this.render(false);
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.mobileQuery && this.mobileQuery.removeEventListener('change', this.onBreakpoint);
      }

      bind() {
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.classList.toggle('is-user-paused', this.userPaused);
            this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
            this.syncVideos();
            this.schedule();
          });
        }

        if (this.hoverPause) {
          this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); });
          this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); });
        }
        this.addEventListener('focusin', () => { this.hovered = true; this.schedule(); });
        this.addEventListener('focusout', () => { this.hovered = false; this.schedule(); });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(this.index - 1);
          if (event.key === 'ArrowRight') this.go(this.index + 1);
        });

        // Swipe
        let startX = 0;
        let startY = 0;
        this.track.addEventListener('pointerdown', (event) => {
          startX = event.clientX;
          startY = event.clientY;
        });
        this.track.addEventListener('pointerup', (event) => {
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        });

        // Pause when off-screen or tab hidden
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.syncVideos();
            this.schedule();
          }, { threshold: 0.25 });
          this.observer.observe(this);
        }
        this.onVisibility = () => { this.syncVideos(); this.schedule(); };
        document.addEventListener('visibilitychange', this.onVisibility);

        // Swap which video plays when crossing the mobile breakpoint
        this.onBreakpoint = () => { this.syncVideos(); this.fit(); };
        this.mobileQuery.addEventListener('change', this.onBreakpoint);

        // Keep the mobile viewport height in step with the active slide
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver((entries) => {
            if (entries.some((entry) => entry.target === this.slides[this.index])) this.fit();
          });
          this.slides.forEach((slide) => this.resizeObserver.observe(slide));
        }

        // Theme editor
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const slide = event.target.closest('[data-lps-slide]');
          const i = this.slides.indexOf(slide);
          if (i < 0) return;
          this.editing = true;
          this.go(i);
        };
        this.onBlockDeselect = (event) => {
          if (!this.contains(event.target)) return;
          this.editing = false;
          this.schedule();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      go(target) {
        if (this.count < 2) return;
        if (target < 0) target = this.loop ? this.count - 1 : 0;
        if (target >= this.count) target = this.loop ? 0 : this.count - 1;
        if (target === this.index) return;
        this.index = target;
        this.render(true);
        this.schedule();
      }

      render(animate) {
        this.track.style.setProperty('--lps-i', this.index);

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-anim', active && animate);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');
        });

        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
          if (this.nextBtn) this.nextBtn.disabled = this.index === this.count - 1;
        }

        this.track.setAttribute('aria-live', this.shouldRun() ? 'off' : 'polite');
        this.syncVideos();
        this.fit();
      }

      // On mobile the viewport takes the height of the active slide, because slides
      // using the desktop fallback (16:9 image + text below) are shorter than the rest.
      fit() {
        if (!this.viewport) return;
        if (!this.mobileQuery.matches) {
          this.viewport.style.height = '';
          this.viewport.style.removeProperty('--lps-arrow-y');
          return;
        }
        const slide = this.slides[this.index];
        const media = slide.querySelector('.lps__media');
        this.viewport.style.height = slide.offsetHeight + 'px';
        this.viewport.style.setProperty(
          '--lps-arrow-y',
          slide.classList.contains('is-stacked') && media ? media.offsetHeight / 2 + 'px' : '50%'
        );
      }

      syncVideos() {
        const canPlay = this.inView && !document.hidden && !this.userPaused && !this.reducedMotion.matches;
        this.slides.forEach((slide, i) => {
          slide.querySelectorAll('video').forEach((video) => {
            const visible = getComputedStyle(video).display !== 'none';
            if (i === this.index && visible && canPlay) {
              const playing = video.play();
              if (playing && typeof playing.catch === 'function') playing.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }

      shouldRun() {
        return (
          this.autoplay &&
          this.count > 1 &&
          !this.userPaused &&
          !this.hovered &&
          !this.editing &&
          this.inView &&
          !document.hidden &&
          !this.reducedMotion.matches
        );
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.shouldRun()) return;
        if (!this.loop && this.index === this.count - 1) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.delay);
      }
    }

    customElements.define('landing-page-slideshow', LandingPageSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
